import { Cat, Dog, Fish, Apple, Banana, Cherry, Star, Heart, Moon } from "lucide-react";

export const PICTURES = [
  { id: "cat", Icon: Cat, color: "#C87D53", label: "Cat" }, { id: "dog", Icon: Dog, color: "#8A5A3C", label: "Dog" }, { id: "fish", Icon: Fish, color: "#1F5C99", label: "Fish" },
  { id: "apple", Icon: Apple, color: "#C0392B", label: "Apple" }, { id: "banana", Icon: Banana, color: "#C9A227", label: "Banana" }, { id: "cherry", Icon: Cherry, color: "#A3245B", label: "Cherry" },
  { id: "star", Icon: Star, color: "#D99B26", label: "Star" }, { id: "heart", Icon: Heart, color: "#D9566B", label: "Heart" }, { id: "moon", Icon: Moon, color: "#3E3560", label: "Moon" },
];
export const pic = (id) => PICTURES.find((p) => p.id === id);
